import { Injectable } from '@angular/core';
import {District} from "../interfaces/district";

@Injectable({
  providedIn: 'root'
})
export class DistrictsService {

  districts: District[] = [
    {
      id: 82,
      name: "Imst",
      icon: 'tirol-imst',
      bkz: 702
    },
    {
      id: 83,
      name: "Innsbruck-Land",
      icon: 'tirol-ibk-land',
      bkz: 703
    },
    {
      id: 81,
      name: "Innsbruck-Stadt",
      icon: 'tirol-ibk-stadt',
      bkz: 701
    },
    {
      id: 84,
      name: "Kitzbühel",
      icon: 'tirol-kitz',
      bkz: 704
    },
    {
      id: 85,
      name: "Kufstein",
      icon: 'tirol-kufstein',
      bkz: 705
    },
    {
      id: 86,
      name: "Landeck",
      icon: 'tirol-landeck',
      bkz: 706
    },
    {
      id: 87,
      name: "Lienz",
      icon: 'tirol-lienz',
      bkz: 707
    },
    {
      id: 88,
      name: "Reutte",
      icon: 'tirol-reutte',
      bkz: 708
    },
    {
      id: 89,
      name: "Schwaz",
      icon: 'tirol-schwaz',
      bkz: 709
    }
  ];
  constructor() { }

  getDistrictNameById(id: number) {
    const filteredDistricts = this.districts.filter(district => district.id === id);

    if(filteredDistricts.length) {
      return filteredDistricts[0].name
    }

    return "";


  }

  getDistrictByName(districtName: string): District | undefined {
    const filteredDistricts = this.districts.filter(district => district.name === districtName);

    if(filteredDistricts.length) {
      return filteredDistricts[0]
    }

    return undefined;

  }
}
